module.exports = __webpack_public_path__ + "static/multi-step-construction-remodel-da0a2e8a9f96e4d59acc5fd190bd9eb6.svg";